import React from "react";
import styles from './Footer.module.scss';
import { Link, useLocation } from "react-router-dom";
import PropTypes from "prop-types";
import { useAuth } from "../../contexts/AuthContext";
import { getHelpLink } from "../../utils/helpLinkUtils";

const Footer = ({
  type = 'main'
}) => {
  const location = useLocation();
  const { role } = useAuth();
  const currentPath = location.pathname;
  const helpLink = getHelpLink(currentPath, role);

  return (
    <div className={`${styles.container} ${styles[type] ?? ''}`}>
      <span className={styles.version}>Version 1.1</span>
      <ul className={styles.links}>
        <li><Link to={helpLink} target="_blank">Help</Link></li>
        <li><Link to="https://logicleap-tech.atlassian.net/servicedesk/customer/kb/view/86605839" target="_blank">Privacy</Link></li>
        <li><Link to="https://logicleap-tech.atlassian.net/servicedesk/customer/portal/1/article/86573057" target="_blank">Terms</Link></li>
      </ul>
    </div>
  );
}

Footer.propTypes = {
  type: PropTypes.oneOf(['main', 'login'])
};

export default Footer;
